import { useStore } from "zustand";
import { ClearRemoveJob, WatchPendingRemoveJob } from "@useCases/index";
import removeJobStore from "@data/stores/removeJob";
import { FirebaseRemoveJobRepository } from "@data/repositories/Firebase/FirebaseRemoveJobRepository";
import { RemoveJob } from "@domain/models/RemoveJob";

export default function useRemoveJob() {
  const { removeJob } = useStore(removeJobStore);

  const watchPendingRemoveJob = async (jobId: RemoveJob["id"]) => {
    const useCase = new WatchPendingRemoveJob(
      new FirebaseRemoveJobRepository(removeJobStore.getState())
    );

    useCase.execute(jobId);
  };

  const cleanRemoveJob = () => {
    const useCase = new ClearRemoveJob(removeJobStore.getState());

    useCase.execute();
  };

  return {
    removeJob,
    watchPendingRemoveJob,
    cleanRemoveJob,
  };
}
